import React from 'react';
import { Box, Button, Typography, Container, useMediaQuery, useTheme, Grid } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

export function FeedbackCTA(props) {
    const theme = useTheme();
    const navigate = useNavigate();
    const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const navigateToFeedback = () => {
        navigate('/feedback');
    };

    const navigateToSurvey = () => {
        navigate('/survey');
    };

    return (
       <Container
                component={'section'}
                maxWidth={isMobileOrTablet ? 'md' : 'xl'}
                sx={{ position: 'relative', py: 4 }}
            >
                <Box
                    bgcolor="#000453"
                    p={0}
                    borderRadius={2}
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    alignItems="stretch"
                    justifyContent="space-between"
                    sx={{
                        height: { xs: 'auto', md: 246 },
                        overflow: 'hidden',
                    }}
                >
                    {/* Left Half */}
                    <Box
                        sx={{
                            flex: 1,
                            paddingLeft: { xs: 2, md: 8 },
                            paddingTop: { xs: 2, md: 0 },
                            paddingBottom: { xs: 2, md: 0 },
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography
                            variant="h3"
                            align="left"
                            color="white"
                            sx={{
                                [theme.breakpoints.down('md')]: {
                                    fontSize: '1.5rem',
                                },
                            }}
                        >
                            Let us know
                        </Typography>
                        <Typography
                            variant="h3"
                            align="left"
                            color="white"
                            sx={{
                                [theme.breakpoints.down('md')]: {
                                    fontSize: '1.5rem',
                                },
                            }}
                        >
                            your thoughts!
                        </Typography>
                    </Box>
                    {/* Right Half */}
                    <Box
                        sx={{
                            flex: 1,
                            padding: { xs: 2, md: 5 },
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Typography color="white">
                            We value your thoughts. Any feedback on your experience is appreciated.
                        </Typography>
                        <Button
                            endIcon={<ArrowForwardIcon />}
                            onClick={navigateToFeedback}
                            variant="contained"
                            sx={{
                                backgroundColor: '#292F68',
                                padding: '20px 24px',
                                borderRadius: '36px',
                                width: 200,
                                mt: 2,
                            }}
                        >
                            Give feedback
                        </Button>
                    </Box>
                </Box>
            </Container>
    );
}
